module.exports = __webpack_public_path__ + "assets/img/29.3b47e274.png";